import React, { Component, PropTypes } from 'react';
import { Table, Form, Pagination, Icon, Spin } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import ComFeeModal from '../Class/ComFeeModal';
import { connect } from 'react-redux';
import { getTeacherClassesById } from 'data/teacher';
import { TableHelper, exportAsExcel } from 'helpers/Table';
import moment from 'moment';
import Utils from 'utils/utils';

const pageLimit = 20;

class TeacherClasses extends Component {
  constructor() {
    super();
    this.onClickRow = this.onClickRow.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.state = {
      collapseMobile: [],
      showModal: false,
      classes: [],
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    const classes = await getTeacherClassesById(this.props.teacher._id);
    this.setState({ classes, loading: false });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onClickRow(record, index) {
    console.log(record, index);
    // this.setState({
    //   showModal: true,
    //   selectedRow: record,
    //   isAddNew: false,
    // });
  }
  onChangePage(page) {
    this.setState(
      {
        page: page,
      },
      () => {
        getTeacherClassesById(this.props.teacher._id, _.merge(this.getCurrentQuery(), { page }));
      },
    );
  }
  onReload = async () => {
    const classes = await getTeacherClassesById(this.props.teacher._id, this.getCurrentQuery());
    this.setState({ classes });
    // this.props.getTeacherClassesById(this.props.teacher._id, this.getCurrentQuery()).then(_.noop);
  };

  onTableChange = (a, b, sorter) => {
    console.log('sorting');
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onReload);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onReload);
    }
  };

  getCurrentQuery() {
    return {
      page: this.state.page,
      sortBy: this.state.sortBy,
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        // props.postNewPageContent(values).then(async () => {
        //   await props.getTeacherClassesById(values.pageName);
        //   this.setState({
        //     showModal: false,
        //   });
        // });
      }
    });
  }

  handleCancel() {
    this.setState({
      showModal: false,
      selectedRow: null,
      isAddNew: false,
      confirmDirty: false,
      getFieldDecorator: false,
      showNewPageModal: false,
    });
  }

  columns = [
    {
      columnName: 'code',
      title: 'No.',
      dataIndex: 'classCode',
      render: (value, record) => (
        <div>
          {' '}
          {value} {record.remark && <Icon type="pushpin" />}
        </div>
      ),
      sorter: true,
    },
    {
      columnName: 'name',
      title: 'Title',
      dataIndex: 'name',
      render: (value, record) => <Link to={`/class/${record._id}`}>{value}</Link>,
    },
    {
      columnName: 'category',
      title: 'Category',
      dataIndex: 'categories',
      render: (value) => value.length > 0 && value[0].name,
    },
    {
      columnName: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (value) => _.startCase(value),
      sorter: true,
    },
    {
      columnName: 'updatedAt',
      title: 'Last update',
      dataIndex: 'updatedAt',
      render: (value) => moment(value).format('DD/MM/YYYY'),
      sorter: true,
    },

    {
      columnName: 'finishedCourseCount',
      title: 'Completion',
      dataIndex: 'finishedCourseCount',
      render: (value) => {
        return value || 0;
      },
      sorter: true,
    },
    {
      columnName: 'studied',
      title: 'Students',
      dataIndex: 'graduatedStudentCount',
      render: (value) => {
        return value || 0;
      },
      sorter: true,
    },
    {
      columnName: 'rating',
      title: 'Reviews',
      dataIndex: 'ratings.averageRatings',
      render: (value, record) => {
        return `${value} (${record.reviewCount})` || 0;
      },
      sorter: true,
    },
    {
      columnName: 'type',
      title: 'Class Type',
      dataIndex: 'classType',
      render: (value) => {
        if (value === 'flexible') return 'Private';
        return _.startCase(value);
      },
    },
  ];

  renderContentTable() {
    const content = _.map(this.state.classes, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });

    return (
      <div>
        <Table columns={this.columns} dataSource={content} bordered pagination={false} onRowClick={this.onClickRow} onChange={this.onTableChange} scroll={{ x: 1400 }} />
        <Pagination className={cn('text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={20} />
      </div>
    );
  }

  render() {
    // const { ordersLoading, approveOrderLoading } = this.props;
    return (
      <div className="content">
        <Spin tip="Loading" size="large" spinning={!!this.state.loading}>
          {this.renderContentTable()}

          <ComFeeModal setIsOpen={(status) => this.setState({ isFeeModalOpen: status })} isOpen={this.state.isFeeModalOpen} classroom={this.state.selectedRow} reload={this.onReload}></ComFeeModal>
        </Spin>
      </div>
    );
  }
}

export default connect((state) => ({}), {
  getTeacherClassesById,
})(Form.create()(TeacherClasses));
